var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"total-btn"},[_c('div',{staticClass:"total-btn__name"},[_vm._v("Всего B")]),_c('div',{staticClass:"total-btn__data"},[_c('div',{},[_vm._v("ml")]),_c('div',[_vm._v(_vm._s(_vm.totalB))])])])}
var staticRenderFns = []

export { render, staticRenderFns }